export default function CriticalIllnessInsurance() {
  return (
    <div className="text-start container mt-3">
      <img
        src="../images/critical-illness-insurance-header.jpg"
        alt="Contact Us"
        className="img-fluid mb-4"
        style={{ width: "100%", height: "600px" }}
      />
      <h1>Critical Illness Insurance</h1>
      <div className="row align-items-center mt-4">
        <div className="col-md-6">
          <p>
            <strong>New Life Financial Services</strong> helps people understand
            how this specific coverage can be a lifesaver during some of the
            most challenging times in their lives.
          </p>
          <p>
            To add a bit more context, it’s important to highlight a few key
            features and benefits that make{" "}
            <strong>Critical Illness Insurance</strong> stand out:
            <ol>
              <li>
                <strong>Lump Sum Payment:</strong> The tax-free lump sum payout
                can be used however the policyholder sees fit. This is
                invaluable, as it provides flexibility—whether it's for paying
                medical bills, replacing lost income, or adjusting their
                lifestyle to meet new physical or logistical needs.
              </li>
              <li>
                <strong>Comprehensive Coverage:</strong> Critical Illness
                Insurance generally covers a wide range of serious conditions
                not only limited to heart attack, stroke, cancer, kidney
                failure, and other life-threatening illnesses but more.
              </li>
              <li>
                <strong>Gap-Filling:</strong> provincial health insurance or
                private health insurance generally doesn’t cover all the costs
                associated with a critical illness. This insurance bridges the
                gap, helping people pay for additional treatments or alternative
                therapies not covered by regular insurance.
              </li>
              <li>
                <strong>Financial Peace of Mind:</strong> The financial strain
                caused by a critical illness can be overwhelming. Losing income
                but bearing the same living cost while facing expensive medical
                treatments is a huge burden.
              </li>
              <li>
                <strong>Claim Process:</strong> One of the key advantages is
                that it’s typically easier and faster to access funds with
                Critical Illness Insurance than with other types of policies
              </li>
            </ol>
          </p>
        </div>
        <div className="col-md-6 justify-content-center d-flex">
          <img
            src="../images/critical-illness-insurance.jpg" // Replace with the actual path to your logo
            alt="New Life Financial Services Logo"
            width="600"
            height="600"
            className="d-inline-block align-top me-2 bg-light rounded-5"
          />
        </div>
      </div>
    </div>
  );
}
